/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delete_Confirm_DeleteInputs */

const he_account_delete_confirm_delete = /** @type {(inputs: Account_Delete_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחק`)
};

const en_account_delete_confirm_delete = /** @type {(inputs: Account_Delete_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Account_Delete_Confirm_DeleteInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delete_confirm_delete = /** @type {((inputs?: Account_Delete_Confirm_DeleteInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delete_Confirm_DeleteInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delete_confirm_delete(inputs)
	return en_account_delete_confirm_delete(inputs)
});